import { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";

import { procurementApi } from "@/main/api";
import KogModalSideComponent from "@/main/components/modal/ModalSide";
import { GetImagePartRequest } from "@/main/models/request";
import { GetImagePartResponse } from "@/main/models/response";
import ModalImagesReturn from "@/main/screens/order/viewOrder/components/modalImagesReturn/modalImagesReturn";
import { FileTypeEnum } from "@/main/services/enum/FileTypeEnum";
import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { hasValueString } from "@/main/services/utilsString";
import { userIsAdmin, userIsBodyshop, userIsInsurer, userIsSupplier } from "@/main/services/utilsUser";

import { useThreeDotsPartClaimContext } from "../context";
import OptionEmptySearchClaim from "../optionEmptySearchClaim";

interface IOptionImagesPartSearchClaimProps {
	guidProcurementSupplierItem: string;
	guidCompany: string;
	idStatus: number;
	isStripePayment: boolean;
}
function OptionImagesPartSearchClaim({ guidProcurementSupplierItem, idStatus }: IOptionImagesPartSearchClaimProps) {
	const { generateIdMenu, closeThreeDotsPartClaim } = useThreeDotsPartClaimContext();

	const [openModalImagesReturn, setOpenModalImagesReturn] = useState(false);
	const [dataImages, setDataImages] = useState<GetImagePartResponse[] | null>(null);
	const [isLoadingImages, setIsLoadingImages] = useState(false);

	const showImagesButton =
		(userIsAdmin() || userIsBodyshop() || userIsInsurer()) &&
		!isLoadingImages &&
		!isNullUndefined(dataImages) &&
		dataImages.length > 0 &&
		(idStatus === ProcurementStatusEnum.ReturnApprovalProcess ||
			idStatus === ProcurementStatusEnum.ReturnProcess ||
			(idStatus === ProcurementStatusEnum.ReturnProcess && userIsSupplier()));

	async function loadImages() {
		setIsLoadingImages(true);
		const request: GetImagePartRequest = {
			guidProcurementSupplierItem: guidProcurementSupplierItem,
			idFileType: FileTypeEnum.ImagePart,
		};

		procurementApi
			.getImagePart(request)
			.then((response) => {
				setDataImages(response.data.result);
			})
			.finally(() => {
				setIsLoadingImages(false);
			});
	}
	function handleClickButtonImages() {
		setOpenModalImagesReturn(true);
		closeThreeDotsPartClaim();
	}
	useEffect(() => {
		const statusToLoadImages = [ProcurementStatusEnum.ReturnProcess, ProcurementStatusEnum.ReturnApprovalProcess];

		if (
			hasValueString(guidProcurementSupplierItem) &&
			statusToLoadImages.includes(idStatus) &&
			!isLoadingImages &&
			isNullUndefined(dataImages)
		) {
			loadImages();
		}
	}, [idStatus, guidProcurementSupplierItem]);

	if (!showImagesButton) return <OptionEmptySearchClaim option="OptionImagesPart" />;
	return (
		<>
			<MenuItem id={generateIdMenu("view-images")} onClick={handleClickButtonImages}>
				{getTranslateByKey("information.viewImages")}
			</MenuItem>
			<KogModalSideComponent
				shouldRenderOpen
				open={openModalImagesReturn}
				title={getTranslateByKey("information.viewImages")}
				closeModal={() => setOpenModalImagesReturn(false)}
			>
				<ModalImagesReturn
					guidProcurementSupplierItem={guidProcurementSupplierItem}
					dataImages={dataImages || []}
					isLoadingImages={isLoadingImages}
				/>
			</KogModalSideComponent>
		</>
	);
}

export default OptionImagesPartSearchClaim;
